import { useT } from './useT';

export function useLanguagesList({ sorted = true } = {}) {
  const t = useT();

  const languages = [
    {
      label: t('LanguagesList.Afrikaans', 'Afrikaans', 'Name of Language'),
      value: 'af',
    },
    { label: t('LanguagesList.Akan', 'Akan', 'Name of Language'), value: 'ak' },
    {
      label: t('LanguagesList.Albanian', 'Albanian', 'Name of Language'),
      value: 'sq',
    },
    {
      label: t('LanguagesList.Arabic', 'Arabic', 'Name of Language'),
      value: 'ar',
    },
    {
      label: t('LanguagesList.Armenian', 'Armenian', 'Name of Language'),
      value: 'hy',
    },
    {
      label: t('LanguagesList.Azerbaijani', 'Azerbaijani', 'Name of Language'),
      value: 'az',
    },
    {
      label: t('LanguagesList.Bambara', 'Bambara', 'Name of Language'),
      value: 'bm',
    },
    {
      label: t('LanguagesList.Basque', 'Basque', 'Name of Language'),
      value: 'eu',
    },
    {
      label: t('LanguagesList.Belarusian', 'Belarusian', 'Name of Language'),
      value: 'be',
    },
    {
      label: t('LanguagesList.Bengali', 'Bengali', 'Name of Language'),
      value: 'bn',
    },
    {
      label: t('LanguagesList.Bosnian', 'Bosnian', 'Name of Language'),
      value: 'bs',
    },
    {
      label: t('LanguagesList.Breton', 'Breton', 'Name of Language'),
      value: 'br',
    },
    {
      label: t('LanguagesList.Bulgarian', 'Bulgarian', 'Name of Language'),
      value: 'bg',
    },
    {
      label: t('LanguagesList.Burmese', 'Burmese', 'Name of Language'),
      value: 'my',
    },
    {
      label: t('LanguagesList.Catalan', 'Catalan', 'Name of Language'),
      value: 'ca',
    },
    {
      label: t(
        'LanguagesList.Central Khmer',
        'Central Khmer',
        'Name of Language'
      ),
      value: 'km',
    },
    {
      label: t('LanguagesList.Chechen', 'Chechen', 'Name of Language'),
      value: 'ce',
    },
    {
      label: t(
        'LanguagesList.Chinese.Simplified',
        'Chinese (Simplified)',
        'Name of Language'
      ),
      value: 'zh-cn',
    },
    {
      label: t(
        'LanguagesList.Chinese.Traditional',
        'Chinese (Traditional)',
        'Name of Language'
      ),
      value: 'zh-tw',
    },
    {
      label: t('LanguagesList.Cornish', 'Cornish', 'Name of Language'),
      value: 'kw',
    },
    {
      label: t('LanguagesList.Croatian', 'Croatian', 'Name of Language'),
      value: 'hr',
    },
    {
      label: t('LanguagesList.Czech', 'Czech', 'Name of Language'),
      value: 'cs',
    },
    {
      label: t('LanguagesList.Danish', 'Danish', 'Name of Language'),
      value: 'da',
    },
    {
      label: t('LanguagesList.Dutch', 'Dutch', 'Name of Language'),
      value: 'nl',
    },
    {
      label: t(
        'LanguagesList.Dutch.Belgium',
        'Dutch (Belgium)',
        'Name of Language'
      ),
      value: 'nl-be',
    },
    {
      label: t(
        'LanguagesList.Dutch.Netherlands',
        'Dutch (Netherlands)',
        'Name of Language'
      ),
      value: 'nl-nl',
    },
    {
      label: t('LanguagesList.Dzongkha', 'Dzongkha', 'Name of Language'),
      value: 'dz',
    },
    {
      label: t('LanguagesList.English', 'English', 'Name of Language'),
      value: 'en',
    },
    {
      label: t(
        'LanguagesList.English.Australia',
        'English (Australia)',
        'Name of Language'
      ),
      value: 'en-au',
    },
    {
      label: t(
        'LanguagesList.English.Belize',
        'English (Belize)',
        'Name of Language'
      ),
      value: 'en-bz',
    },
    {
      label: t(
        'LanguagesList.English.Canada',
        'English (Canada)',
        'Name of Language'
      ),
      value: 'en-ca',
    },
    {
      label: t(
        'LanguagesList.English.Ireland',
        'English (Ireland)',
        'Name of Language'
      ),
      value: 'en-ie',
    },
    {
      label: t(
        'LanguagesList.English.Jamaica',
        'English (Jamaica)',
        'Name of Language'
      ),
      value: 'en-jm',
    },
    {
      label: t(
        'LanguagesList.English.NewZealand',
        'English (New Zealand)',
        'Name of Language'
      ),
      value: 'en-nz',
    },
    {
      label: t(
        'LanguagesList.English.Phillipines',
        'English (Phillipines)',
        'Name of Language'
      ),
      value: 'en-ph',
    },
    {
      label: t(
        'LanguagesList.English.SouthAfrica',
        'English (South Africa)',
        'Name of Language'
      ),
      value: 'en-za',
    },
    {
      label: t(
        'LanguagesList.English.Trinidad',
        'English (Trinidad)',
        'Name of Language'
      ),
      value: 'en-tt',
    },
    {
      label: t(
        'LanguagesList.English.UnitedKingdom',
        'English (United Kingdom)',
        'Name of Language'
      ),
      value: 'en-gb',
    },
    {
      label: t(
        'LanguagesList.English.UnitedStates',
        'English (United States)',
        'Name of Language'
      ),
      value: 'en-us',
    },
    {
      label: t(
        'LanguagesList.English.Zimbabwe',
        'English (Zimbabwe)',
        'Name of Language'
      ),
      value: 'en-zw',
    },
    {
      label: t('LanguagesList.Esperanto', 'Esperanto', 'Name of Language'),
      value: 'eo',
    },
    {
      label: t('LanguagesList.Estonian', 'Estonian', 'Name of Language'),
      value: 'et',
    },
    { label: t('LanguagesList.Ewe', 'Ewe', 'Name of Language'), value: 'ee' },
    {
      label: t('LanguagesList.Faeroese', 'Faeroese', 'Name of Language'),
      value: 'fo',
    },
    {
      label: t('LanguagesList.Filipino', 'Filipino', 'Name of Language'),
      value: 'fil',
    },
    {
      label: t('LanguagesList.Finnish', 'Finnish', 'Name of Language'),
      value: 'fi',
    },
    {
      label: t('LanguagesList.French', 'French', 'Name of Language'),
      value: 'fr',
    },
    {
      label: t(
        'LanguagesList.French.Belgium',
        'French (Belgium)',
        'Name of Language'
      ),
      value: 'fr-be',
    },
    {
      label: t(
        'LanguagesList.French.Canada',
        'French (Canada)',
        'Name of Language'
      ),
      value: 'fr-ca',
    },
    {
      label: t(
        'LanguagesList.French.France',
        'French (France)',
        'Name of Language'
      ),
      value: 'fr-fr',
    },
    {
      label: t(
        'LanguagesList.French.Luxembourg',
        'French (Luxembourg)',
        'Name of Language'
      ),
      value: 'fr-lu',
    },
    {
      label: t(
        'LanguagesList.French.Monaco',
        'French (Monaco)',
        'Name of Language'
      ),
      value: 'fr-mc',
    },
    {
      label: t(
        'LanguagesList.French.Switzerland',
        'French (Switzerland)',
        'Name of Language'
      ),
      value: 'fr-ch',
    },
    {
      label: t('LanguagesList.Fulah', 'Fulah', 'Name of Language'),
      value: 'ff',
    },
    {
      label: t('LanguagesList.Gaelic', 'Gaelic', 'Name of Language'),
      value: 'gd',
    },
    {
      label: t('LanguagesList.Galician', 'Galician', 'Name of Language'),
      value: 'gl',
    },
    {
      label: t('LanguagesList.Ganda', 'Ganda', 'Name of Language'),
      value: 'lg',
    },
    {
      label: t('LanguagesList.Georgian', 'Georgian', 'Name of Language'),
      value: 'ka',
    },
    {
      label: t('LanguagesList.German', 'German', 'Name of Language'),
      value: 'de',
    },
    {
      label: t(
        'LanguagesList.German.Austria',
        'German (Austria)',
        'Name of Language'
      ),
      value: 'de-at',
    },
    {
      label: t(
        'LanguagesList.German.Germany',
        'German (Germany)',
        'Name of Language'
      ),
      value: 'de-de',
    },
    {
      label: t(
        'LanguagesList.German.Liechtenstein',
        'German (Liechtenstein)',
        'Name of Language'
      ),
      value: 'de-li',
    },
    {
      label: t(
        'LanguagesList.German.Luxembourg',
        'German (Luxembourg)',
        'Name of Language'
      ),
      value: 'de-lu',
    },
    {
      label: t(
        'LanguagesList.German.Switzerland',
        'German (Switzerland)',
        'Name of Language'
      ),
      value: 'de-ch',
    },
    {
      label: t('LanguagesList.Greek', 'Greek', 'Name of Language'),
      value: 'el',
    },
    {
      label: t('LanguagesList.Gujarati', 'Gujarati', 'Name of Language'),
      value: 'gu',
    },
    {
      label: t('LanguagesList.Hausa', 'Hausa', 'Name of Language'),
      value: 'ha',
    },
    {
      label: t('LanguagesList.Hawaiian', 'Hawaiian', 'Name of Language'),
      value: 'haw',
    },
    {
      label: t('LanguagesList.Hebrew', 'Hebrew', 'Name of Language'),
      value: 'he',
    },
    {
      label: t('LanguagesList.Hindi', 'Hindi', 'Name of Language'),
      value: 'hi',
    },
    {
      label: t('LanguagesList.Hungarian', 'Hungarian', 'Name of Language'),
      value: 'hu',
    },
    {
      label: t('LanguagesList.Icelandic', 'Icelandic', 'Name of Language'),
      value: 'is',
    },
    { label: t('LanguagesList.Igbo', 'Igbo', 'Name of Language'), value: 'ig' },
    {
      label: t('LanguagesList.Indonesian', 'Indonesian', 'Name of Language'),
      value: 'in',
    },
    {
      label: t('LanguagesList.Inuktitut', 'Inuktitut', 'Name of Language'),
      value: 'iu',
    },
    {
      label: t('LanguagesList.Irish', 'Irish', 'Name of Language'),
      value: 'ga',
    },
    {
      label: t('LanguagesList.Italian', 'Italian', 'Name of Language'),
      value: 'it',
    },
    {
      label: t(
        'LanguagesList.Italian.Italy',
        'Italian (Italy)',
        'Name of Language'
      ),
      value: 'it-it',
    },
    {
      label: t(
        'LanguagesList.Italian.Switzerland',
        'Italian (Switzerland)',
        'Name of Language'
      ),
      value: 'it-ch',
    },
    {
      label: t('LanguagesList.Japanese', 'Japanese', 'Name of Language'),
      value: 'ja',
    },
    {
      label: t('LanguagesList.Kalaallisut', 'Kalaallisut', 'Name of Language'),
      value: 'kl',
    },
    {
      label: t('LanguagesList.Kannada', 'Kannada', 'Name of Language'),
      value: 'kn',
    },
    {
      label: t('LanguagesList.Kashmiri', 'Kashmiri', 'Name of Language'),
      value: 'ks',
    },
    {
      label: t('LanguagesList.Kazakh', 'Kazakh', 'Name of Language'),
      value: 'kk',
    },
    {
      label: t('LanguagesList.Kikuyu', 'Kikuyu', 'Name of Language'),
      value: 'ki',
    },
    {
      label: t('LanguagesList.Kinyarwanda', 'Kinyarwanda', 'Name of Language'),
      value: 'rw',
    },
    {
      label: t('LanguagesList.Kirghiz', 'Kirghiz', 'Name of Language'),
      value: 'ky',
    },
    {
      label: t('LanguagesList.Korean', 'Korean', 'Name of Language'),
      value: 'ko',
    },
    { label: t('LanguagesList.Lao', 'Lao', 'Name of Language'), value: 'lo' },
    {
      label: t('LanguagesList.Latvian', 'Latvian', 'Name of Language'),
      value: 'lv',
    },
    {
      label: t('LanguagesList.Lingala', 'Lingala', 'Name of Language'),
      value: 'ln',
    },
    {
      label: t('LanguagesList.Lithuanian', 'Lithuanian', 'Name of Language'),
      value: 'lt',
    },
    {
      label: t(
        'LanguagesList.Luba-Katanga',
        'Luba-Katanga',
        'Name of Language'
      ),
      value: 'lu',
    },
    {
      label: t(
        'LanguagesList.Luxembourgish',
        'Luxembourgish',
        'Name of Language'
      ),
      value: 'lb',
    },
    {
      label: t('LanguagesList.Macedonian', 'Macedonian', 'Name of Language'),
      value: 'mk',
    },
    {
      label: t('LanguagesList.Malagasy', 'Malagasy', 'Name of Language'),
      value: 'mg',
    },
    {
      label: t('LanguagesList.Malay', 'Malay', 'Name of Language'),
      value: 'ms',
    },
    {
      label: t('LanguagesList.Malayalam', 'Malayalam', 'Name of Language'),
      value: 'ml',
    },
    {
      label: t('LanguagesList.Maltese', 'Maltese', 'Name of Language'),
      value: 'mt',
    },
    { label: t('LanguagesList.Manx', 'Manx', 'Name of Language'), value: 'gv' },
    {
      label: t('LanguagesList.Marathi', 'Marathi', 'Name of Language'),
      value: 'mr',
    },
    {
      label: t('LanguagesList.Mongolian', 'Mongolian', 'Name of Language'),
      value: 'mn',
    },
    {
      label: t(
        'LanguagesList.Ndebele, North',
        'Ndebele, North',
        'Name of Language'
      ),
      value: 'nd',
    },
    {
      label: t(
        'LanguagesList.Ndebele, South',
        'Ndebele, South',
        'Name of Language'
      ),
      value: 'nr',
    },
    {
      label: t('LanguagesList.Nepali', 'Nepali', 'Name of Language'),
      value: 'ne',
    },
    {
      label: t(
        'LanguagesList.Northern Sami',
        'Northern Sami',
        'Name of Language'
      ),
      value: 'se',
    },
    {
      label: t('LanguagesList.Norwegian', 'Norwegian', 'Name of Language'),
      value: 'no',
    },
    {
      label: t(
        'LanguagesList.Norwegian.Bokmål',
        'Norwegian Bokmål',
        'Name of Language'
      ),
      value: 'nb',
    },
    {
      label: t(
        'LanguagesList.Norwegian.Nynorsk',
        'Norwegian Nynorsk',
        'Name of Language'
      ),
      value: 'nn',
    },
    {
      label: t('LanguagesList.Oromo', 'Oromo', 'Name of Language'),
      value: 'om',
    },
    {
      label: t('LanguagesList.Ossetian', 'Ossetian', 'Name of Language'),
      value: 'os',
    },
    {
      label: t('LanguagesList.Panjabi', 'Panjabi', 'Name of Language'),
      value: 'pa',
    },
    {
      label: t('LanguagesList.Persian', 'Persian', 'Name of Language'),
      value: 'fa',
    },
    {
      label: t('LanguagesList.Polish', 'Polish', 'Name of Language'),
      value: 'pl',
    },
    {
      label: t('LanguagesList.Portuguese', 'Portuguese', 'Name of Language'),
      value: 'pt',
    },
    {
      label: t(
        'LanguagesList.Portuguese.Brazil',
        'Portuguese (Brazil)',
        'Name of Language'
      ),
      value: 'pt-br',
    },
    {
      label: t(
        'LanguagesList.Portuguese.Portugal',
        'Portuguese (Portugal)',
        'Name of Language'
      ),
      value: 'pt-pt',
    },
    {
      label: t('LanguagesList.Quechua', 'Quechua', 'Name of Language'),
      value: 'qu',
    },
    {
      label: t('LanguagesList.Romanian', 'Romanian', 'Name of Language'),
      value: 'ro',
    },
    {
      label: t(
        'LanguagesList.Romanian.Moldova',
        'Romanian (Moldova)',
        'Name of Language'
      ),
      value: 'ro-mo',
    },
    {
      label: t(
        'LanguagesList.Romanian.Romania',
        'Romanian (Romania)',
        'Name of Language'
      ),
      value: 'ro-ro',
    },
    {
      label: t('LanguagesList.Romansh', 'Romansh', 'Name of Language'),
      value: 'rm',
    },
    {
      label: t('LanguagesList.Rundi', 'Rundi', 'Name of Language'),
      value: 'rn',
    },
    {
      label: t('LanguagesList.Russian', 'Russian', 'Name of Language'),
      value: 'ru',
    },
    {
      label: t(
        'LanguagesList.Russian.Moldova',
        'Russian (Moldova)',
        'Name of Language'
      ),
      value: 'ru-mo',
    },
    {
      label: t(
        'LanguagesList.Russian.Russia',
        'Russian (Russia)',
        'Name of Language'
      ),
      value: 'ru-ru',
    },
    {
      label: t('LanguagesList.Sango', 'Sango', 'Name of Language'),
      value: 'sg',
    },
    {
      label: t('LanguagesList.Serbian', 'Serbian', 'Name of Language'),
      value: 'sr',
    },
    {
      label: t('LanguagesList.Shona', 'Shona', 'Name of Language'),
      value: 'sn',
    },
    {
      label: t('LanguagesList.SichuanYi', 'Sichuan Yi', 'Name of Language'),
      value: 'ii',
    },
    {
      label: t('LanguagesList.Sinhala', 'Sinhala', 'Name of Language'),
      value: 'si',
    },
    {
      label: t('LanguagesList.Slovak', 'Slovak', 'Name of Language'),
      value: 'sk',
    },
    {
      label: t('LanguagesList.Slovenian', 'Slovenian', 'Name of Language'),
      value: 'sl',
    },
    {
      label: t('LanguagesList.Somali', 'Somali', 'Name of Language'),
      value: 'so',
    },
    {
      label: t('LanguagesList.Spanish', 'Spanish', 'Name of Language'),
      value: 'es',
    },
    {
      label: t(
        'LanguagesList.Spanish.Argentina',
        'Spanish (Argentina)',
        'Name of Language'
      ),
      value: 'es-ar',
    },
    {
      label: t(
        'LanguagesList.Spanish.Bolivia',
        'Spanish (Bolivia)',
        'Name of Language'
      ),
      value: 'es-bo',
    },
    {
      label: t(
        'LanguagesList.Spanish.Chile',
        'Spanish (Chile)',
        'Name of Language'
      ),
      value: 'es-cl',
    },
    {
      label: t(
        'LanguagesList.Spanish.Colombia',
        'Spanish (Colombia)',
        'Name of Language'
      ),
      value: 'es-co',
    },
    {
      label: t(
        'LanguagesList.Spanish.CostaRica)',
        'Spanish (Costa Rica)',
        'Name of Language'
      ),
      value: 'es-cr',
    },
    {
      label: t(
        'LanguagesList.Spanish.DominicanRepublic)',
        'Spanish (Dominican Republic)',
        'Name of Language'
      ),
      value: 'es-do',
    },
    {
      label: t(
        'LanguagesList.Spanish.Ecuador',
        'Spanish (Ecuador)',
        'Name of Language'
      ),
      value: 'es-ec',
    },
    {
      label: t(
        'LanguagesList.Spanish.ElSalvador)',
        'Spanish (El Salvador)',
        'Name of Language'
      ),
      value: 'es-sv',
    },
    {
      label: t(
        'LanguagesList.Spanish.Guatemala',
        'Spanish (Guatemala)',
        'Name of Language'
      ),
      value: 'es-gt',
    },
    {
      label: t(
        'LanguagesList.Spanish.Honduras',
        'Spanish (Honduras)',
        'Name of Language'
      ),
      value: 'es-hn',
    },
    {
      label: t(
        'LanguagesList.Spanish.Mexico',
        'Spanish (Mexico)',
        'Name of Language'
      ),
      value: 'es-mx',
    },
    {
      label: t(
        'LanguagesList.Spanish.Nicaragua',
        'Spanish (Nicaragua)',
        'Name of Language'
      ),
      value: 'es-ni',
    },
    {
      label: t(
        'LanguagesList.Spanish.Panama',
        'Spanish (Panama)',
        'Name of Language'
      ),
      value: 'es-pa',
    },
    {
      label: t(
        'LanguagesList.Spanish.Paraguay',
        'Spanish (Paraguay)',
        'Name of Language'
      ),
      value: 'es-py',
    },
    {
      label: t(
        'LanguagesList.Spanish.Peru',
        'Spanish (Peru)',
        'Name of Language'
      ),
      value: 'es-pe',
    },
    {
      label: t(
        'LanguagesList.Spanish.PuertoRico',
        'Spanish (Puerto Rico)',
        'Name of Language'
      ),
      value: 'es-pr',
    },
    {
      label: t(
        'LanguagesList.Spanish.Spain',
        'Spanish (Spain)',
        'Name of Language'
      ),
      value: 'es-es',
    },
    {
      label: t(
        'LanguagesList.Spanish.Uruguay',
        'Spanish (Uruguay)',
        'Name of Language'
      ),
      value: 'es-uy',
    },
    {
      label: t(
        'LanguagesList.Spanish.Venezuela',
        'Spanish (Venezuela)',
        'Name of Language'
      ),
      value: 'es-ve',
    },
    {
      label: t('LanguagesList.Swahili', 'Swahili', 'Name of Language'),
      value: 'sw',
    },
    {
      label: t('LanguagesList.Swedish', 'Swedish', 'Name of Language'),
      value: 'sv',
    },
    {
      label: t(
        'LanguagesList.Swedish.Finland',
        'Swedish (Finland)',
        'Name of Language'
      ),
      value: 'sv-fi',
    },
    {
      label: t(
        'LanguagesList.Swedish.Sweden',
        'Swedish (Sweden)',
        'Name of Language'
      ),
      value: 'sv-se',
    },
    {
      label: t('LanguagesList.Tagalog', 'Tagalog', 'Name of Language'),
      value: 'tl',
    },
    {
      label: t('LanguagesList.Tajik', 'Tajik', 'Name of Language'),
      value: 'tg',
    },
    {
      label: t('LanguagesList.Tamil', 'Tamil', 'Name of Language'),
      value: 'ta',
    },
    {
      label: t('LanguagesList.Tatar', 'Tatar', 'Name of Language'),
      value: 'tt',
    },
    {
      label: t('LanguagesList.Telugu', 'Telugu', 'Name of Language'),
      value: 'te',
    },
    { label: t('LanguagesList.Thai', 'Thai', 'Name of Language'), value: 'th' },
    {
      label: t('LanguagesList.Tibetan', 'Tibetan', 'Name of Language'),
      value: 'bo',
    },
    {
      label: t('LanguagesList.Tigrinya', 'Tigrinya', 'Name of Language'),
      value: 'ti',
    },
    {
      label: t(
        'LanguagesList.Tonga.TongaIslands',
        'Tonga (Tonga Islands)',
        'Name of Language'
      ),
      value: 'to',
    },
    {
      label: t('LanguagesList.Turkish', 'Turkish', 'Name of Language'),
      value: 'tr',
    },
    {
      label: t('LanguagesList.Turkmen', 'Turkmen', 'Name of Language'),
      value: 'tk',
    },
    {
      label: t('LanguagesList.Uighur', 'Uighur', 'Name of Language'),
      value: 'ug',
    },
    {
      label: t('LanguagesList.Ukrainian', 'Ukrainian', 'Name of Language'),
      value: 'uk',
    },
    {
      label: t('LanguagesList.Ukranian', 'Ukranian', 'Name of Language'),
      value: 'uk',
    },
    { label: t('LanguagesList.Urdu', 'Urdu', 'Name of Language'), value: 'ur' },
    {
      label: t('LanguagesList.Uzbek', 'Uzbek', 'Name of Language'),
      value: 'uz',
    },
    {
      label: t('LanguagesList.Vietnamese', 'Vietnamese', 'Name of Language'),
      value: 'vi',
    },
    {
      label: t('LanguagesList.Welsh', 'Welsh', 'Name of Language'),
      value: 'cy',
    },
    {
      label: t('LanguagesList.Wolof', 'Wolof', 'Name of Language'),
      value: 'wo',
    },
    {
      label: t('LanguagesList.Yiddish', 'Yiddish', 'Name of Language'),
      value: 'yi',
    },
    {
      label: t('LanguagesList.Yoruba', 'Yoruba', 'Name of Language'),
      value: 'yo',
    },
    { label: t('LanguagesList.Zulu', 'Zulu', 'Name of Language'), value: 'zu' },
  ];

  return sorted
    ? languages.sort((a, b) => a.label.localeCompare(b.label))
    : languages;
}
